<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" ref="vuemodal" id="EditBankModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">銀行情報の設定</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form :class="this.wasValidated ? 'was-validated' : ''">
              <div class='table-scroll-wrapper mb-4'>
                <table class='table table-sm table-striped table-500'>
                  <thead>
                  <tr>
                    <th>取引先</th>
                    <th>銀行名</th>
                  </tr>
                  </thead>
                  <tbody class="nowrap">
                  <template v-for="(detail, i) in updatedClients">
                    <tr :key="i">
                      <td style="font-size: medium; vertical-align: middle">{{ detail.name }}</td>
                      <td style="width: 310px"><select
                        class='form-control'
                        v-model="detail.bank"
                        >
                        <option
                          v-for="bank in banks"
                          :key="bank.value"
                          :value="bank.value"
                        >
                          {{bank.label}}
                        </option>
                      </select></td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div>
              <button ref="closeEditUserModal" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>&nbsp;
              <button type="submit" class="btn btn-primary" v-on:click="validateBeforeUpdate">更新</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BankCompany } from '@/constants'

export default {
  name: 'EditBankModal',
  props: {},
  data () {
    return {
      wasValidated: false,
      isLoading: false,
      clients: [],
      banks: []
    }
  },
  created () {
    this.listClients()
    this.banks = BankCompany
  },
  mounted () {
  },
  computed: {
    updatedClients () {
      return this.clients.map(detail => {
        if (!detail.bank) {
          detail.bank = this.banks[0].value
        }
        return detail
      })
    }
  },
  methods: {
    listClients: async function () {
      try {
        let cList = await this.$http.post(this.$api_url.client_list)
        if (cList.data && cList.data.status === true) {
          this.clients = cList.data.list
        } else {
          this.clients = [{ id: 0, name: 'No record.' }]
          this.$toastr.error(cList.data.message, 'エラー')
        }
      } catch (e) {
        console.log('error: ', e)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    validateBeforeUpdate: function () {
      var self = this
      self.$validator
        .validateAll()
        .then(function (response) {
          if (response === true) {
            self.updateBankCompany()
          }
          self.wasValidated = true
        })
        .catch(function (e) {
          // Catch errors
        })
    },
    async updateBankCompany () {
      var self = this
      try {
        self.isLoading = true

        let params = {
          clients: self.clients
        }
        let result = await this.$http.post(this.$api_url.update_client, params)
        if (result.data.status === true) {
          this.$toastr.success('情報更新が完了しました。', 'Success')
          self.wasValidated = false
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('clients:change_bank_company:catch(error): ', error)
      }
    }
  }
}
</script>

<style>
.table-scroll-wrapper {
  max-height: 600px;
  overflow-y: auto
}
</style>
